/*
 * Keeps the in-store block in step with the variant picker.
 *
 * Without this the block would render once and then lie: variant-picker.js
 * calls fetchUpdatedSection and only re-renders components that register for
 * ThemeEvents.variantUpdate, so a shopper switching from a size that is on the
 * Chadstone shelf to one that is not would keep reading the first answer.
 *
 * Deliberately a copy of product-inventory.js rather than a shared base: the
 * two blocks morph independently, and coupling them would mean a change to the
 * online chip could silently alter the in-store one.
 */
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class StoreStock extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStoreStock);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStoreStock);
  }

  /**
   * Replaces the rows for the newly selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStoreStock = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const incoming = event.detail.data.html.querySelector('store-stock');

    /*
     * No incoming element means the new variant resolved to "render nothing"
     * (no payload entry, pre-order, or an unresolved store). Removing our own
     * children is the correct response: leaving the previous variant's answer
     * on screen is the one failure mode this block must never have.
     */
    if (!incoming) {
      this.replaceChildren();
      return;
    }

    morph(this, incoming, { childrenOnly: true });
  };
}

if (!customElements.get('store-stock')) {
  customElements.define('store-stock', StoreStock);
}
